/* eslint-disable implicit-arrow-linebreak */
import { PRIMARY_BUTTON_COLOR, DANGER_BUTTON_COLOR, icons } from "../../common/alerts/constants";

const buildFooter = (infoText) => `
    <small>
        <i class="fas fa-info-circle text-info"></i>
        &ensp;${infoText}
    </small>`;

export const alterFinalizarDescarga = () =>
    Swal.fire({
        icon: icons.warning,
        title: "Sin materiales",
        html: "No se encontraron más materiales que descargar",
        showCancelButton: true,
        confirmButtonText: "Finalizar descargo",
        confirmButtonColor: PRIMARY_BUTTON_COLOR,
        cancelButtonText: "Cancelar descargo",
        cancelButtonColor: DANGER_BUTTON_COLOR,
        allowOutsideClick: false,
        footer: buildFooter("Si finalizas la descarga, el pedimento será descargado completamente"),
    });

export const alertCancelarDescarga = () =>
    Swal.fire({
        icon: icons.question,
        title: "¿Realmente deseas cancelar el desargo?",
        showCancelButton: true,
        confirmButtonText: "Aceptar",
        confirmButtonColor: PRIMARY_BUTTON_COLOR,
        cancelButtonText: "Cancelar",
        cancelButtonColor: DANGER_BUTTON_COLOR,
        allowOutsideClick: false,
        footer: buildFooter("Si cancelas la descarga, cualquier cambio realizado será descartado"),
    });

export const alertSinPedimentoSeleccionado = () =>
    Swal.fire({
        icon: icons.warning,
        title: "Sin pedimento",
        text: "No se ha seleccionado ningún pedimento para descargar",
        confirmButtonText: "Aceptar",
        confirmButtonColor: PRIMARY_BUTTON_COLOR,
    });

export const alertDescargaOk = () =>
    Swal.fire({
        icon: icons.success,
        title: "Descarga",
        html: "Descarga realizada correctamente",
        confirmButtonText: "Aceptar",
        confirmButtonColor: PRIMARY_BUTTON_COLOR,
    });

export const alertSinFechaVencimiento = (data) =>
    Swal.fire({
        icon: icons.warning,
        title: "Fecha de Vencimiento sin calcular",
        html: `No se pudo calcular la fecha de vencimiento de los siguientes pedimentos<br><br>${data}`,
        confirmButtonText: "Aceptar",
        confirmButtonColor: PRIMARY_BUTTON_COLOR,
    });

export const alertPedimentosIncompletos = (data) =>
    Swal.fire({
        icon: icons.warning,
        title: "Pedimentos incompletos",
        html: `
            Los siguientes pedimentos contienen mercancías que no se pueden descargar
            debido a que no tienen un material asignado:<br/><br/>${data}
        `,
        confirmButtonText: "Aceptar",
        confirmButtonColor: PRIMARY_BUTTON_COLOR,
    });

export const alertSinPedimentosParaDescargar = () =>
    Swal.fire({
        icon: icons.info,
        title: "Sin pedimentos",
        text: "No se encontraron pedimentos para descargar en el rango de fechas especificado",
        confirmButtonText: "Aceptar",
        confirmButtonColor: PRIMARY_BUTTON_COLOR,
    });
